"use client";
import OneMindFeatures from "@/components/oneMindFeatures";
import { CSPM_CONSTANTS } from "./constants";

const InclusionComp = () => {
  return <OneMindFeatures {...CSPM_CONSTANTS} />;
};

export default InclusionComp;
